import { render, staticRenderFns } from "./HRSalaryModal.vue?vue&type=template&id=87bbdd7e&scoped=true&"
import script from "./HRSalaryModal.vue?vue&type=script&lang=js&"
export * from "./HRSalaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bbdd7e",
  null
  
)

export default component.exports